export default __webpack_public_path__ + "static/media/gallery-wip-bunny-ears_04.6c58780c.jpg";